import {BarChart} from '@/_metronic/partials/content/chart/BarChart'
import {useQueryRequest} from '@/app/modules/report-trend-analysis/core/QueryRequestProvider'
import moment from 'moment'
import {useEffect, useMemo, useState} from 'react'
import {useGetReportMainDashboard} from '../core/_query'
import {getCSSVariableValue} from '@/_metronic/assets/ts/_utils'

const ReportMainDashboard = () => {
  const {state} = useQueryRequest()
  // console.log('state report main dashboard', state)
  const {data: mainDashboardData, isLoading} = useGetReportMainDashboard(state)

  const data = useMemo(() => {
    const isFiltered = state.set_sub_brand_id ?? false

    var finalResult = mainDashboardData?.response?.data

    if (isFiltered && (state.sub_brand_name ?? []).length > 0 && finalResult) {
      const filteredGrossRevenue =
        finalResult?.gross_revenue_last_year_vs_this_year_list?.[state.sub_brand_name![0]]
      const filteredRevenueShare =
        finalResult?.revenue_share_alaya_last_year_vs_this_year_list?.[state.sub_brand_name![0]]

      // Handle YTD summary filtering if structured similarly
      const filteredGrossRevenueYtd =
        finalResult?.gross_revenue_ytd_last_year_vs_ytd_this_year_summary?.[
          state.sub_brand_name![0]
        ]
      const filteredRevenueShareYtd =
        finalResult?.revenue_share_alaya_ytd_last_year_vs_ytd_this_year_summary?.[
          state.sub_brand_name![0]
        ]

      finalResult = {
        ...finalResult,
        gross_revenue_last_year_vs_this_year_list: Array.isArray(filteredGrossRevenue)
          ? filteredGrossRevenue
          : [],
        revenue_share_alaya_last_year_vs_this_year_list: Array.isArray(filteredRevenueShare)
          ? filteredRevenueShare
          : [],
        gross_revenue_ytd_last_year_vs_ytd_this_year_summary:
          filteredGrossRevenueYtd !== undefined
            ? Array.isArray(filteredGrossRevenueYtd)
              ? filteredGrossRevenueYtd
              : typeof filteredGrossRevenueYtd === 'object'
              ? [filteredGrossRevenueYtd]
              : []
            : finalResult?.gross_revenue_ytd_last_year_vs_ytd_this_year_summary,
        revenue_share_alaya_ytd_last_year_vs_ytd_this_year_summary:
          filteredRevenueShareYtd !== undefined
            ? Array.isArray(filteredRevenueShareYtd)
              ? filteredRevenueShareYtd
              : typeof filteredRevenueShareYtd === 'object'
              ? [filteredRevenueShareYtd]
              : []
            : finalResult?.revenue_share_alaya_ytd_last_year_vs_ytd_this_year_summary,
      }
    }

    return finalResult
  }, [mainDashboardData, state.set_sub_brand_id, state.sub_brand_name])

  //Revenue Sharing
  const [arrayOfSeriesGrossRevenueThisYear, setArrayOfSeriesGrossRevenueThisYear] = useState<
    number[]
  >([])
  const [arrayOfSeriesGrossRevenueLastYear, setArrayOfSeriesGrossRevenueLastYear] = useState<
    number[]
  >([])
  const [arrayOfSeriesRevenueShareThisYear, setArrayOfSeriesRevenueShareThisYear] = useState<
    number[]
  >([])
  const [arrayOfSeriesRevenueShareLastYear, setArrayOfSeriesRevenueShareLastYear] = useState<
    number[]
  >([])
  const [arrayOfSeriesGrossRevenueThisYearToDate, setArrayOfSeriesGrossRevenueThisYearToDate] =
    useState<number[]>([])
  const [arrayOfSeriesRevenueShareThisYearToDate, setArrayOfSeriesRevenueShareThisYearToDate] =
    useState<number[]>([])
  const [arrayOfSeriesGrossRevenueLastYearToDate, setArrayOfSeriesGrossRevenueLastYearToDate] =
    useState<number[]>([])
  const [arrayOfSeriesRevenueShareLastYearToDate, setArrayOfSeriesRevenueShareLastYearToDate] =
    useState<number[]>([])
  const [arrayOfSeriesGrossRevenueThisMonth, setArrayOfSeriesGrossRevenueThisMonth] = useState<
    number[]
  >([])
  const [arrayOfSeriesRevenueShareThisMonth, setArrayOfSeriesRevenueShareThisMonth] = useState<
    number[]
  >([])
  const [arrayOfSeriesGrossRevenueLastMonth, setArrayOfSeriesGrossRevenueLastMonth] = useState<
    number[]
  >([])
  const [arrayOfSeriesRevenueShareLastMonth, setArrayOfSeriesRevenueShareLastMonth] = useState<
    number[]
  >([])
  const [arrayOfSeriesGrossRevenueBudget, setArrayOfSeriesGrossRevenueBudget] = useState<
    number[]
  >([])
  const [arrayOfSeriesRevenueShareBudget, setArrayOfSeriesRevenueShareBudget] = useState<
    number[]
  >([])
  const [arrayOfSeriesGrossRevenueBudgetYtd, setArrayOfSeriesGrossRevenueBudgetYtd] = useState<
    number[]
  >([])
  const [arrayOfSeriesRevenueShareBudgetYtd, setArrayOfSeriesRevenueShareBudgetYtd] = useState<
    number[]
  >([])
  const [arrayOfSeriesGrossRevenueBudgetThisMonth, setArrayOfSeriesGrossRevenueBudgetThisMonth] = useState<
    number[]
  >([])
  const [arrayOfSeriesRevenueShareBudgetThisMonth, setArrayOfSeriesRevenueShareBudgetThisMonth] = useState<
    number[]
  >([])
  const [arrayOfSeriesGrossRevenueBudgetLastMonth, setArrayOfSeriesGrossRevenueBudgetLastMonth] = useState<
    number[]
  >([])
  const [arrayOfSeriesRevenueShareBudgetLastMonth, setArrayOfSeriesRevenueShareBudgetLastMonth] = useState<
    number[]
  >([])
  const [arrayOfLabelsGuestType, setArrayOfLabelsGuestType] = useState<string[]>([])
  const yearComparisonLegendItems = useMemo(
    () => [
      {label: 'Revenue This Year', color: getCSSVariableValue('--bs-primary')},
      {label: 'Revenue Last Year', color: getCSSVariableValue('--bs-gray-300')},
      {label: 'Budget', color: '#4C9BFA'},
    ],
    []
  )

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, '.')
  }

  useEffect(() => {
    setArrayOfSeriesGrossRevenueThisYear([])
    setArrayOfSeriesGrossRevenueLastYear([])
    setArrayOfSeriesRevenueShareThisYear([])
    setArrayOfSeriesRevenueShareLastYear([])
    setArrayOfSeriesGrossRevenueThisMonth([])
    setArrayOfSeriesRevenueShareThisMonth([])
    setArrayOfSeriesGrossRevenueLastMonth([])
    setArrayOfSeriesRevenueShareLastMonth([])
    setArrayOfSeriesGrossRevenueThisYearToDate([])
    setArrayOfSeriesRevenueShareThisYearToDate([])
    setArrayOfSeriesGrossRevenueLastYearToDate([])
    setArrayOfSeriesRevenueShareLastYearToDate([])
    setArrayOfSeriesGrossRevenueBudget([])
    setArrayOfSeriesRevenueShareBudget([])
    setArrayOfSeriesGrossRevenueBudgetYtd([])
    setArrayOfSeriesRevenueShareBudgetYtd([])
    setArrayOfSeriesGrossRevenueBudgetThisMonth([])
    setArrayOfSeriesRevenueShareBudgetThisMonth([])
    setArrayOfSeriesGrossRevenueBudgetLastMonth([])
    setArrayOfSeriesRevenueShareBudgetLastMonth([])
    setArrayOfLabelsGuestType([])

    //Report Booking Type
    if (data) {
      // Debug: Log YTD data structure to understand the issue
      // console.log('YTD Data Structure:', {
      //   gross_revenue_ytd: data?.gross_revenue_ytd_last_year_vs_ytd_this_year_summary,
      //   revenue_share_ytd: data?.revenue_share_alaya_ytd_last_year_vs_ytd_this_year_summary,
      //   isArray_gross: Array.isArray(data?.gross_revenue_ytd_last_year_vs_ytd_this_year_summary),
      //   isArray_revenue: Array.isArray(
      //     data?.revenue_share_alaya_ytd_last_year_vs_ytd_this_year_summary
      //   ),
      // })

      //This Year vs Last Year
      const isFiltered = state.set_sub_brand_id ?? false
      const arrayOfLabelsGuestTypeString = Array.isArray(
        data?.gross_revenue_last_year_vs_this_year_list
      )
        ? data.gross_revenue_last_year_vs_this_year_list.map((obj) => (obj.month ? obj.month : ''))
        : []
      setArrayOfLabelsGuestType(arrayOfLabelsGuestTypeString || [])
      const arrayOfSeriesGrossRevenueThisYearString = Array.isArray(
        data?.gross_revenue_last_year_vs_this_year_list
      )
        ? data.gross_revenue_last_year_vs_this_year_list.map((obj, index) => {
            var value = obj.total_this_year ? obj.total_this_year : 0

            // if (!isFiltered && Number(state.year || '0') === 2024) {
            //   if (obj.month === 'January') {
            //     return 1768795196
            //   }
            //   if (obj.month === 'February') {
            //     return 1648506857
            //   }
            //   if (obj.month === 'March') {
            //     return 1288314583
            //   }
            //   if (obj.month === 'April') {
            //     return 1292755724
            //   }
            // }

            return value
          })
        : []
      setArrayOfSeriesGrossRevenueThisYear(arrayOfSeriesGrossRevenueThisYearString || [])
      const arrayOfSeriesCabinString = Array.isArray(
        data?.revenue_share_alaya_last_year_vs_this_year_list
      )
        ? data.revenue_share_alaya_last_year_vs_this_year_list.map((obj) =>
            obj.total_this_year ? obj.total_this_year : 0
          )
        : []
      setArrayOfSeriesRevenueShareThisYear(arrayOfSeriesCabinString || [])
      const arrayOfSeriesInRoomString = Array.isArray(
        data?.revenue_share_alaya_last_year_vs_this_year_list
      )
        ? data.revenue_share_alaya_last_year_vs_this_year_list.map((obj) =>
            obj.total_last_year ? obj.total_last_year : 0
          )
        : []
      setArrayOfSeriesRevenueShareLastYear(arrayOfSeriesInRoomString || [])

      const arrayOfSeriesGuestHotelString = Array.isArray(
        data?.gross_revenue_last_year_vs_this_year_list
      )
        ? data.gross_revenue_last_year_vs_this_year_list.map((obj, index) => {
            var value = obj.total_last_year ? obj.total_last_year : 0

            // if (!isFiltered && Number(state.year || '0') === 2025) {
            //   if (obj.month === 'January') {
            //     return 1768795196
            //   }
            //   if (obj.month === 'February') {
            //     return 1648506857
            //   }
            //   if (obj.month === 'March') {
            //     return 1288314583
            //   }
            //   if (obj.month === 'April') {
            //     return 1292755724
            //   }
            // }

            return value
          })
        : []
      setArrayOfSeriesGrossRevenueLastYear(arrayOfSeriesGuestHotelString || [])

      // Budget data for This Year vs Last Year charts
      const arrayOfSeriesGrossRevenueBudgetString = Array.isArray(
        data?.gross_revenue_last_year_vs_this_year_list
      )
        ? data.gross_revenue_last_year_vs_this_year_list.map((obj) =>
            obj.total_budget ? obj.total_budget : 0
          )
        : []
      setArrayOfSeriesGrossRevenueBudget(arrayOfSeriesGrossRevenueBudgetString || [])

      const arrayOfSeriesRevenueShareBudgetString = Array.isArray(
        data?.revenue_share_alaya_last_year_vs_this_year_list
      )
        ? data.revenue_share_alaya_last_year_vs_this_year_list.map((obj) =>
            obj.total_budget ? obj.total_budget : 0
          )
        : []
      setArrayOfSeriesRevenueShareBudget(arrayOfSeriesRevenueShareBudgetString || [])

      //This Month vs Last Month
      const currentMonth = moment().format('MMMM')
      const lastMonth = moment().subtract(1, 'months').format('MMMM')

      const grossRevenueThisMonth = Array.isArray(data?.gross_revenue_last_year_vs_this_year_list)
        ? data.gross_revenue_last_year_vs_this_year_list.filter((obj) => obj.month === currentMonth)
        : []
      const revenueShareAlayaThisMonth = Array.isArray(
        data?.revenue_share_alaya_last_year_vs_this_year_list
      )
        ? data.revenue_share_alaya_last_year_vs_this_year_list.filter(
            (obj) => obj.month === currentMonth
          )
        : []

      const grossRevenueLastMonth = Array.isArray(data?.gross_revenue_last_year_vs_this_year_list)
        ? data.gross_revenue_last_year_vs_this_year_list.filter((obj) => obj.month === lastMonth)
        : []
      const revenueShareAlayaLastMonth = Array.isArray(
        data?.revenue_share_alaya_last_year_vs_this_year_list
      )
        ? data.revenue_share_alaya_last_year_vs_this_year_list.filter(
            (obj) => obj.month === lastMonth
          )
        : []

      const arrayOfSeriesgrossRevenueThisMonthString = grossRevenueThisMonth?.map((obj) =>
        obj.total_this_year ? obj.total_this_year : 0
      )
      setArrayOfSeriesGrossRevenueThisMonth(arrayOfSeriesgrossRevenueThisMonthString || [])
      const arrayOfSeriesRevenueShareAlayaThisMonthString = revenueShareAlayaThisMonth?.map((obj) =>
        obj.total_this_year ? obj.total_this_year : 0
      )
      setArrayOfSeriesRevenueShareThisMonth(arrayOfSeriesRevenueShareAlayaThisMonthString || [])
      const arrayOfSeriesgrossRevenueLastMonthString = grossRevenueLastMonth?.map((obj) =>
        obj.total_this_year ? obj.total_this_year : 0
      )
      setArrayOfSeriesGrossRevenueLastMonth(arrayOfSeriesgrossRevenueLastMonthString || [])
      const arrayOfSeriesGuestHotelInRoomString = revenueShareAlayaLastMonth?.map((obj) =>
        obj.total_this_year ? obj.total_this_year : 0
      )
      setArrayOfSeriesRevenueShareLastMonth(arrayOfSeriesGuestHotelInRoomString || [])

      // Budget data for This Month vs Last Month charts
      const arrayOfSeriesGrossRevenueBudgetThisMonthString = grossRevenueThisMonth?.map((obj) =>
        obj.total_budget ? obj.total_budget : 0
      )
      setArrayOfSeriesGrossRevenueBudgetThisMonth(arrayOfSeriesGrossRevenueBudgetThisMonthString || [])
      const arrayOfSeriesRevenueShareBudgetThisMonthString = revenueShareAlayaThisMonth?.map((obj) =>
        obj.total_budget ? obj.total_budget : 0
      )
      setArrayOfSeriesRevenueShareBudgetThisMonth(arrayOfSeriesRevenueShareBudgetThisMonthString || [])
      const arrayOfSeriesGrossRevenueBudgetLastMonthString = grossRevenueLastMonth?.map((obj) =>
        obj.total_budget ? obj.total_budget : 0
      )
      setArrayOfSeriesGrossRevenueBudgetLastMonth(arrayOfSeriesGrossRevenueBudgetLastMonthString || [])
      const arrayOfSeriesRevenueShareBudgetLastMonthString = revenueShareAlayaLastMonth?.map((obj) =>
        obj.total_budget ? obj.total_budget : 0
      )
      setArrayOfSeriesRevenueShareBudgetLastMonth(arrayOfSeriesRevenueShareBudgetLastMonthString || [])

      //Gross and Share Revenue Year to Date
      // Handle both array and object cases for YTD summary
      const grossRevenueYtd = data?.gross_revenue_ytd_last_year_vs_ytd_this_year_summary
      const revenueShareYtd = data?.revenue_share_alaya_ytd_last_year_vs_ytd_this_year_summary

      // Convert to array if it's an object, or use as-is if it's already an array
      const grossRevenueYtdArray = Array.isArray(grossRevenueYtd)
        ? grossRevenueYtd
        : grossRevenueYtd && typeof grossRevenueYtd === 'object'
        ? [grossRevenueYtd]
        : []

      const revenueShareYtdArray = Array.isArray(revenueShareYtd)
        ? revenueShareYtd
        : revenueShareYtd && typeof revenueShareYtd === 'object'
        ? [revenueShareYtd]
        : []

      const arrayOfSeriesGrossRevenueThisYearToDateString = grossRevenueYtdArray.map((obj) =>
        obj?.total_this_year ? obj.total_this_year : 0
      )
      setArrayOfSeriesGrossRevenueThisYearToDate(
        arrayOfSeriesGrossRevenueThisYearToDateString || []
      )

      const arrayOfSeriesRevenueShareAlayaThisYearToDateString = revenueShareYtdArray.map((obj) =>
        obj?.total_this_year ? obj.total_this_year : 0
      )
      setArrayOfSeriesRevenueShareThisYearToDate(
        arrayOfSeriesRevenueShareAlayaThisYearToDateString || []
      )

      const arrayOfSeriesGrossRevenueLastYearToDateString = grossRevenueYtdArray.map((obj) =>
        obj?.total_last_year ? obj.total_last_year : 0
      )
      setArrayOfSeriesGrossRevenueLastYearToDate(
        arrayOfSeriesGrossRevenueLastYearToDateString || []
      )

      const arrayOfSeriesRevenueShareAlayaLastYearToDateString = revenueShareYtdArray.map((obj) =>
        obj?.total_last_year ? obj.total_last_year : 0
      )
      setArrayOfSeriesRevenueShareLastYearToDate(
        arrayOfSeriesRevenueShareAlayaLastYearToDateString || []
      )

      // Budget data for Year to Date charts
      const arrayOfSeriesGrossRevenueBudgetYtdString = grossRevenueYtdArray.map((obj) =>
        obj?.total_budget ? obj.total_budget : 0
      )
      setArrayOfSeriesGrossRevenueBudgetYtd(arrayOfSeriesGrossRevenueBudgetYtdString || [])

      const arrayOfSeriesRevenueShareBudgetYtdString = revenueShareYtdArray.map((obj) =>
        obj?.total_budget ? obj.total_budget : 0
      )
      setArrayOfSeriesRevenueShareBudgetYtd(arrayOfSeriesRevenueShareBudgetYtdString || [])
    }
  }, [data])

  return (
    <>
      <div className='col-xl-12 g-5 g-xl-8 pt-5'>
        {/* Gross Revenue This Year VS Last Year with Year to Date */}
        <div className='row g-5'>
          <div className='col-lg-8 col-12'>
            <BarChart
              className='area-wib shadow-wit h-100'
              color='primary'
              title={`Gross Revenue ${
                (state.sub_brand_name && state.sub_brand_name?.[0]) || 'OIC'
              } This Year VS Last Year`}
              subtitle=''
              height='400px'
              series={[
                {
                  name: 'Gross Revenue This Year',
                  data: arrayOfSeriesGrossRevenueThisYear,
                },
                {
                  name: 'Gross Revenue Last Year',
                  data: arrayOfSeriesGrossRevenueLastYear,
                },
                {
                  name: 'Budget',
                  data: arrayOfSeriesGrossRevenueBudget,
                },
              ]}
              categories={arrayOfLabelsGuestType}
              total={0}
              isTotal={false}
              isCurrency={true}
              isLoading={
                isLoading || (mainDashboardData?.response?.message_en as any) === 'no result data'
              }
              customLegendItems={yearComparisonLegendItems}
            />
          </div>
          <div className='col-lg-4 col-12'>
            <BarChart
              className='area-wib shadow-wit h-100'
              color='primary'
              title={`Gross Revenue ${
                (state.sub_brand_name && state.sub_brand_name?.[0]) || 'OIC'
              } Year to Date`}
              subtitle=''
              height='400px'
              series={[
                {
                  name: 'This Year',
                  data: arrayOfSeriesGrossRevenueThisYearToDate,
                },
                {
                  name: 'Last Year',
                  data: arrayOfSeriesGrossRevenueLastYearToDate,
                },
                {
                  name: 'Budget',
                  data: arrayOfSeriesGrossRevenueBudgetYtd,
                },
              ]}
              categories={['This Year vs Last Year']}
              total={0}
              isTotal={false}
              isCurrency={true}
              isLoading={
                isLoading || (mainDashboardData?.response?.message_en as any) === 'no result data'
              }
              customLegendItems={yearComparisonLegendItems}
            />
          </div>
        </div>

        {/* Revenue Share This Year VS Last Year with Year to Date */}
        <div className='row g-5 mt-5'>
          <div className='col-lg-8 col-12'>
            <BarChart
              className='area-wib shadow-wit h-100'
              color='primary'
              title={`Revenue Share ${
                (state.sub_brand_name && state.sub_brand_name?.[0]) || 'OIC'
              } This Year VS Last Year`}
              subtitle=''
              height='400px'
              series={[
                {
                  name: 'Revenue Share This Year',
                  data: arrayOfSeriesRevenueShareThisYear,
                },
                {
                  name: 'Revenue Share Last Year',
                  data: arrayOfSeriesRevenueShareLastYear,
                },
                {
                  name: 'Budget',
                  data: arrayOfSeriesRevenueShareBudget,
                },
              ]}
              categories={arrayOfLabelsGuestType}
              total={0}
              isTotal={false}
              isCurrency={true}
              isLoading={
                isLoading || (mainDashboardData?.response?.message_en as any) === 'no result data'
              }
              customLegendItems={yearComparisonLegendItems}
            />
          </div>
          <div className='col-lg-4 col-12'>
            <BarChart
              className='area-wib shadow-wit h-100'
              color='primary'
              title={`Revenue Share ${
                (state.sub_brand_name && state.sub_brand_name?.[0]) || 'OIC'
              } Year to Date`}
              subtitle=''
              height='400px'
              series={[
                {
                  name: 'This Year',
                  data: arrayOfSeriesRevenueShareThisYearToDate,
                },
                {
                  name: 'Last Year',
                  data: arrayOfSeriesRevenueShareLastYearToDate,
                },
                {
                  name: 'Budget',
                  data: arrayOfSeriesRevenueShareBudgetYtd,
                },
              ]}
              categories={['This Year vs Last Year']}
              total={0}
              isTotal={false}
              isCurrency={true}
              isLoading={
                isLoading || (mainDashboardData?.response?.message_en as any) === 'no result data'
              }
              customLegendItems={yearComparisonLegendItems}
            />
          </div>
        </div>

        {/* Gross and Share Revenue This Month vs Last Month */}
        <div className='row'>
          <div className='col-lg-6 col-12'>
            <BarChart
              className='mt-10 area-wib shadow-wit'
              color='primary'
              title={`Gross Revenue ${
                (state.sub_brand_name && state.sub_brand_name?.[0]) || 'OIC'
              } This Month vs Last Month`}
              subtitle=''
              height='400px'
              series={[
                {
                  name: 'This Month',
                  data: arrayOfSeriesGrossRevenueThisMonth,
                },
                {
                  name: 'Last Month',
                  data: arrayOfSeriesGrossRevenueLastMonth,
                },
                {
                  name: 'Budget',
                  data: arrayOfSeriesGrossRevenueBudgetThisMonth,
                },
              ]}
              categories={['This Month vs Last Month']}
              total={0}
              isTotal={false}
              isCurrency={true}
              isLoading={
                isLoading || (mainDashboardData?.response?.message_en as any) === 'no result data'
              }
            />
          </div>
          <div className='col-lg-6 col-12'>
            <BarChart
              className='mt-10 area-wib shadow-wit'
              color='primary'
              title={`Revenue Share ${
                (state.sub_brand_name && state.sub_brand_name?.[0]) || 'OIC'
              } This Month vs Last Month`}
              subtitle=''
              height='400px'
              series={[
                {
                  name: 'This Month',
                  data: arrayOfSeriesRevenueShareThisMonth,
                },
                {
                  name: 'Last Month',
                  data: arrayOfSeriesRevenueShareLastMonth,
                },
                {
                  name: 'Budget',
                  data: arrayOfSeriesRevenueShareBudgetThisMonth,
                },
              ]}
              categories={['This Month vs Last Month']}
              total={0}
              isTotal={false}
              isCurrency={true}
              isLoading={
                isLoading || (mainDashboardData?.response?.message_en as any) === 'no result data'
              }
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default ReportMainDashboard
